
import React from 'react';
export default function UncalledToggle({ value, onChange }){
  return (<label className='checkbox' title='Show only leads with no Date Called'>
    <input type='checkbox' checked={!!value} onChange={e=>onChange(e.target.checked)} />
    <span>Uncalled only</span>
  </label>);
}
